/**
 * Pola telefonu: wyłącznie cyfry, 9–15 (kontrakt polish_phone / PhoneNormalizer).
 */

const PHONE_MAX_DIGITS = 15;

function extractPhoneDigits(raw) {
    return String(raw || '').replace(/\D/g, '').slice(0, PHONE_MAX_DIGITS);
}

function bindPhoneInput(input) {
    if (!input || input.dataset.phoneDigitsBound === '1') {
        return;
    }
    input.dataset.phoneDigitsBound = '1';

    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('maxlength', String(PHONE_MAX_DIGITS));

    const restrict = () => {
        const digits = extractPhoneDigits(input.value);
        if (input.value === digits) {
            return;
        }

        input.value = digits;

        // Bez syntetycznego input/change — Chrome wtedy często przerywa batch autofill
        // (e-mail + imię + telefon w jednej rundzie). Livewire aktualizujemy bezpośrednio.
        const wireModel =
            input.getAttribute('wire:model') ||
            input.getAttribute('wire:model.live') ||
            input.getAttribute('wire:model.defer') ||
            input.getAttribute('wire:model.blur');
        if (wireModel && window.Livewire) {
            const root = input.closest('[wire\\:id]');
            const component = root && window.Livewire.find(root.getAttribute('wire:id'));
            if (component) {
                component.set(wireModel, digits);
            }
        }
    };

    // rAF: normalizacja po zakończeniu wpisu/autofill, nie w środku batcha Chrome.
    input.addEventListener('input', () => {
        window.requestAnimationFrame(restrict);
    });
    input.addEventListener('blur', restrict);
}

function initPhoneDigits(root = document) {
    root.querySelectorAll(
        [
            'input[type="tel"]',
            'input[name="telephone"]',
            'input[name="telefon"]',
            'input[name$=".telephone"]',
            'input[name$=".telefon"]',
            'input[id="telephone"]',
            'input[id="telefon"]',
            'input[id^="telephone_"]',
            'input[id^="telefon_"]',
            'input.js-phone-digits',
        ].join(', ')
    ).forEach(bindPhoneInput);
}

module.exports = {
    initPhoneDigits,
    bindPhoneInput,
    extractPhoneDigits,
};
